import dynamic from 'next/dynamic';
import { useEffectOnce } from 'react-use';
import { AccountSettingsTeamPermissionsSkeleton } from 'src/components/AccountSettingsTeamPermissions/AccountSettingsTeamPermissionsSkeleton';
import { AgentPageLayout } from 'src/components/AgentPageLayout';
import { useAgentTeamId } from '@/utils/use-agent-team-id';
import { useTeamId } from '@/utils/use-team-id';
import { AnalyticsEvent, useTrackEvent } from '$analytics';

const AccountSettingsTeamPermissions = dynamic(
  () =>
    import(
      'src/components/AccountSettingsTeamPermissions/AccountSettingsTeamPermissions'
    ).then((exported) => exported.AccountSettingsTeamPermissions),
  { ssr: false, loading: () => <AccountSettingsTeamPermissionsSkeleton /> },
);

export default function AgentAccountProfilePage() {
  const { agentTeamId, userinfo, isLoading, error } = useAgentTeamId();
  const userId = userinfo?.id;
  const teamId = useTeamId(userinfo, agentTeamId);

  const trackEvent = useTrackEvent();
  useEffectOnce(() => {
    trackEvent(AnalyticsEvent.AccountManagement, {
      eventContainer: 'team_management',
      eventTarget: 'team_management',
    });
  });

  if (isLoading) {
    return <AccountSettingsTeamPermissionsSkeleton />;
  }

  // TODO: Improve this generic error with more accurate messaging that
  // distinguishes a network failure from genuinely missing data.
  if (error !== undefined) {
    throw new Error('Failed to load user team information');
  }

  // TODO: Improve this generic error with more accurate messaging that
  // distinguishes a missing user from a missing team.
  if (!userId || !teamId) {
    throw new Error('Unable to load user');
  }

  return <AccountSettingsTeamPermissions userId={userId} teamId={teamId} />;
}

AgentAccountProfilePage.Layout = AgentPageLayout;
